export const NONE=0
export const BOTTOM_RIGHT=1
export const BOTTOM_LEFT=2
export const TOP_RIGHT=3
export const TOP_LEFT=4

export const POSITION_STYLES = {
  [NONE]: {
    display: 'none'
  },
  [TOP_LEFT]: {
    top: '20px',
    right: 'auto',
    bottom: 'auto',
    left: '20px'
  },
  [TOP_RIGHT]: {
    top: '20px',
    right: '20px',
    bottom: 'auto',
    left: 'auto'
  },
  [BOTTOM_RIGHT]: {
    top: 'auto',
    right: '20px',
    bottom: '20px',
    left: 'auto'
  },
  [BOTTOM_LEFT]: {
    top: 'auto',
    right: 'auto',
    bottom: '20px',
    left: '20px'
  }
}

export const MUTE_TYPE_VIDEO = 0
export const MUTE_TYPE_AUDIO = 1
export const MUTE_TYPE_SPEAKER = 2

export const WEBRTC_CALL_CONNECTED = 'Webrtc_call_connected'
export const WEBRTC_CALL_DISCONNECTED = 'Webrtc_call_disconnected'
export const PIP_POSITION_CHANGED = 'pip_position_changed'
export const VIDEO_MUTED = 'video_muted'
export const VIDEO_UNMUTED = 'video_unmuted'
export const AUDIO_MUTED = 'audio_muted'
export const AUDIO_UNMUTED = 'audio_unmuted'
export const SPEAKER_MUTED = 'speaker_muted'
export const SPEAKER_UNMUTED = 'speaker_unmuted'

export const FLEX10_DEVICE_TYPE = 'VIS_STATION_V5.0A'

export const SUSPENDED = 'suspended'
